import { render, staticRenderFns } from "./ConcentrationsComponent.vue?vue&type=template&id=8e046870&"
import script from "./ConcentrationsComponent.vue?vue&type=script&lang=js&"
export * from "./ConcentrationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports